const LayoutDefault = () => import('@/layout/Default');

const BatchActions = () => import('@/views/BatchActions/index.vue');

export default {
  path: '/acoes-em-massa',
  component: LayoutDefault,
  children: [
    { path: 'executar', name: 'BatchActions', component: BatchActions },
  ],
};
